import { createSlice } from '@reduxjs/toolkit';

const drawerSlice = createSlice({
  name: 'drawer',
  initialState: {
    isShown: false,
  },
  reducers: {
    openDrawer: (state) => {
      state.isShown = true;
    },
    closeDrawer: (state) => {
      state.isShown = false
    }
  },
});

export const {
  openDrawer,
  closeDrawer
} = drawerSlice.actions;

export default drawerSlice.reducer;
